import { render } from "./RescheduleActivity.vue?vue&type=template&id=20b03584&scoped=true"
import script from "./RescheduleActivity.vue?vue&type=script&lang=js"
export * from "./RescheduleActivity.vue?vue&type=script&lang=js"

import "./RescheduleActivity.vue?vue&type=style&index=0&id=20b03584&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20b03584"]])

export default __exports__